export const SET_IS_LOADING = 'app/SET_IS_LOADING';
export const SET_IS_NOT_LOADING = 'app/SET_IS_NOT_LOADING';
export const SHOW_MODAL = 'app/SHOW_MODAL';
export const HIDE_MODAL = 'app/HIDE_MODAL';
export const SHOW_AUTH_SUCCESS = 'app/SHOW_AUTH_SUCCESS';
export const SET_IS_DASHBOARD_LOADED = 'app/SET_IS_DASHBOARD_LOADED';
export const SET_AUTH_ERROR = 'auth/SET_AUTH_ERROR';
